import { useMutation } from 'Data/Api.js'
import { useDataValue } from 'Simple/Data.js'
import { normalizePath, useSetFlowTo } from 'Simple/Flow.js'
import { notifyError, useNotifications } from 'Logic/Notifications.js'

import mutationRollbackAppointmentState from './mutation-rollback-appointment-state.graphql.js'

/** @type {import('Simple/types.js').useDataOnSubmit} */
export default function useDataOnSubmit(props) {
  let setFlowTo = useSetFlowTo(props.viewPath)

  let appointment = useDataValue({
    context: 'event',
    path: 'appointment',
    viewPath: props.viewPath,
  })

  let [, executeMutationRollbackAppointmentState] = useMutation(
    mutationRollbackAppointmentState
  )
  let [, notify] = useNotifications()

  return async function onSubmit({ args }) {
    switch (args) {
      case 'DELETE':
        return deleteAppointment()
      case 'SCHEDULE_VIA_SMS_OR_EMAIL':
        return scheduleViaSmsOrEmail()
      case 'GENERATE_LETTERS':
        return generateLetters()
      case 'OLD_GENERATE_LETTERS':
        return oldGenerateLetters()
      case 'APPOINTMENT_HISTORY':
        return showAppointmentHistory()
      case 'APPOINTMENT_ADD':
        return addAppointment()
      case 'MOVE_TO_ANOTHER_TREATMENT':
        return moveToAnotherTreatment()
      case 'CHANGE_APPOINTMENT_DURATION':
        return changeAppointmentDuration()
      case 'CANCEL_NO_SHOW':
        return cancelNoShow()
      default:
        return
    }
    function deleteAppointment() {
      setFlowTo(normalizePath(props.viewPath, 'Delete/Content'))
    }

    function addAppointment() {
      setFlowTo(normalizePath(props.viewPath, 'AddAppointment/Content'))
    }

    function showAppointmentHistory() {
      setFlowTo(normalizePath(props.viewPath, 'AppointmentHistory/Content'))
    }

    async function scheduleViaSmsOrEmail() {
      setFlowTo(normalizePath(props.viewPath, 'ScheduleViaSmsOrEmail/Content'))
    }

    function generateLetters() {
      setFlowTo(normalizePath(props.viewPath, 'GenerateLetters/Content'))
    }

    function oldGenerateLetters() {
      setFlowTo(normalizePath(props.viewPath, 'OldGenerateLetters/Content'))
    }

    function moveToAnotherTreatment() {
      setFlowTo(normalizePath(props.viewPath, 'MoveToAnotherTreatment/Content'))
    }

    function changeAppointmentDuration() {
      setFlowTo(
        normalizePath(props.viewPath, 'ChangeAppointmentDuration/Content')
      )
    }

    async function cancelNoShow() {
      let mutationResponse = await executeMutationRollbackAppointmentState({
        id: appointment.booking._id,
      })
      if (mutationResponse.error) {
        notify(
          notifyError(
            `There was a problem marking the appointment as no show. Please try again.`
          )
        )
      }
    }
  }
}
